<template>
    <DxDataGrid id="grid" :show-borders="true" :data-source="contracts" key-expr="ID" :repaint-changes-only="true">
        <DxColumn data-field="number" caption="№ Договора"> </DxColumn>
        <DxColumn data-field="subdivision" caption="Подразделение" />
        <DxColumn data-field="vid" caption="Вид договора" />
        <DxColumn data-field="start_date" caption="Дата начала" />
        <DxColumn data-field="end_date" caption="Дата окончания, план" />
        <DxColumn data-field="termination_date" caption="Дата прекращения" />
        <DxColumn data-field="sign_date" caption="Дата подписания" />
        <DxColumn data-field="creation_date" caption="Дата заключения" />
        <DxColumn data-field="delivery_start_date" caption="Дата начала поставки э/э" />
        <DxColumn data-field="source_data" caption="Источник данных" />
        <DxPaging :page-size="5" />
        <DxPager
            :visible="true"
            :allowed-page-sizes="3"
            display-mode="full"
            :show-page-size-selector="true"
            :show-info="true"
            :show-navigation-buttons="true"
        />
    </DxDataGrid>
</template>

<script setup>
import { inject } from 'vue';
import { DxDataGrid, DxColumn, DxPager, DxPaging } from 'devextreme-vue/data-grid';

const data = inject('serverData');
console.log(data);

const contracts = [
    {
        ID: 1,
        number: '10923 Т',
        subdivision: 'ИП Комиссаренко Валерий Валерьевич',
        vid: '13456',
        start_date: 'У',
        end_date: '31.05.2008',
        termination_date: '12.07.2009',
        sign_date: '12.09.2005',
        creation_date: '12.09.2005',
        delivery_start_date: '',
        source_data: 'АСУСЭ',
    },
    {
        ID: 2,
        number: '11923 Т',
        subdivision: 'ИП Комиссаренко Валерий Валерьевич',
        vid: '13456',
        start_date: 'А',
        end_date: '31.05.2008',
        termination_date: '12.07.2009',
        sign_date: '12.09.2005',
        creation_date: '12.09.2005',
        delivery_start_date: '',
        source_data: 'АСУСЭ',
    },
    {
        ID: 3,
        number: '11923 Т',
        subdivision: 'ИП Комиссаренко Валерий Валерьевич',
        vid: '13456',
        start_date: 'А',
        end_date: '31.05.2008',
        termination_date: '12.07.2009',
        sign_date: '12.09.2005',
        creation_date: '12.09.2005',
        delivery_start_date: '',
        source_data: 'АСУСЭ',
    },
    {
        ID: 4,
        number: '11923 Т',
        subdivision: 'ИП Комиссаренко Валерий Валерьевич',
        vid: '13456',
        start_date: 'А',
        end_date: '31.05.2008',
        termination_date: '12.07.2009',
        sign_date: '12.09.2005',
        creation_date: '12.09.2005',
        delivery_start_date: '',
        source_data: 'АСУСЭ',
    },
    {
        ID: 5,
        number: '11923 Т',
        subdivision: 'ИП Комиссаренко Валерий Валерьевич',
        vid: '13456',
        start_date: 'А',
        end_date: '31.05.2008',
        termination_date: '12.07.2009',
        sign_date: '12.09.2005',
        creation_date: '12.09.2005',
        delivery_start_date: '',
        source_data: 'АСУСЭ',
    },
];
</script>
